/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { safeEncodeUrl } from '../../utility/primitiveManipulation.js';
import { isTrackonomicsLinkWrapperConfig } from '../typeGuards/commerceDataTypes.js';
import { TRACKONOMICS_WRAP_HOST } from './constants.js';
const TX_ADDL_PARAMS = ['author', 'page_type', 'partner', 'section', 'site_id', 'mc'];
export default function trackonomicsLinkWrapper(linkUrl, config) {
    if (!isTrackonomicsLinkWrapperConfig(config) || config.options === undefined) {
        return linkUrl;
    }
    if (linkUrl.includes(TRACKONOMICS_WRAP_HOST)) {
        // do not wrap something that already includes the host.
        // we are not checking the exact host of the url, as the trackonomics wrap
        // may itself have been wrapped
        return linkUrl;
    }
    if (config.options !== undefined) {
        Object.entries(config.options).forEach(([key, value]) => {
            if (value === undefined || value === '') {
                delete config.options?.[key];
            }
        });
    }
    const options = config.options;
    const urlParams = [];
    urlParams.push(`event_type=${options?.eventType ?? 'click'}`);
    urlParams.push(`q=${safeEncodeUrl(linkUrl)}`);
    if (options.pageUrl !== undefined) {
        const pageUrl = encodeURIComponent(decodeURIComponent(options.pageUrl));
        urlParams.push(`p=${pageUrl}`);
    }
    if (options.item_id !== undefined) {
        urlParams.push(`ContentId=${options.item_id}`);
    }
    urlParams.push(...TX_ADDL_PARAMS.filter((paramName) => options[paramName] !== undefined).map((paramName) => `${paramName}=${encodeURIComponent(options[paramName])}`));
    return `https://${TRACKONOMICS_WRAP_HOST}/xid/${config.options.siteCode}?${urlParams.join('&')}`;
}
//# sourceMappingURL=trackonomicsLinkWrapper.js.map